import React from "react";
import { ReactDOMComponents } from '../../utilities/ReactDOMComponents';
import PropertyPanelWidget from '../PropertyPanelWidget';
/**
 * UI for merging application versions with options for resolving conflicts 
 *
 * @class CommonModuleDefaultsDialog
 * @extends {React.Component}
 */
export default class CommonModuleDefaultsDialog extends React.Component {
    /**
     * Dialog for used in reference check
     * @module CommonModuleDefaultsDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);

        this.state = {
            disabledMapLoaded: false,
            disabledPathMap: null,
            disabledModules: null
        }

        this.reactDOMComponents = new ReactDOMComponents();
    }

    /**
     * React Lifecycle method
     *
     */
    componentDidMount() {
        this.init();
    }

    /**
     * Initialize merge by getting version changeMaps and identifying conflicts 
     *
     */
    init() {
        
    }

    getPropertyPanel(){    
        return (
            <PropertyPanelWidget 
                context={this.props.module}
                embed={true}
                configViewType={'commonModuleDefaults'}
            />    
        );
    
    }
        

    /**
     * React render
     * @returns {XML}
     */
    render() {

        return (

            <div style={{height: '100%'}} >
                    <div style={{ padding: '10px 0px 16px', margin: '10px', padding: '1.2em'}}>
                        {/* <h4 style={{marginTop: '0'}}>Disabled Modules</h4> */}
                        {this.getPropertyPanel(this.props.module)}
                    </div>


            </div>

        );

    }
}

//
                    